export const FETCH_ALL = 'FETCH_ALL';
export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';
export const UPDATE_ASKED_COUNT = 'UPDATE_ASKED_COUNT';

export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_GUESS_ENTRY = 'GET_GUESS_ENTRY';
export const UPDATE_DAILY_ENTRY = 'UPDATE_DAILY_ENTRY';
export const UPDATE_GUESS_INFO = 'UPDATE_GUESS_INFO';
export const FETCH_USERS = 'FETCH_USERS';

export const START = 'START';
export const RESET = 'RESET';
export const STOP = 'STOP';
export const NEXT_OR_PREV = 'NEXT_OR_PREV';
export const RESTART = 'RESTART';
